import { type FC } from "react";
import { useDoc, useView } from "use-pouchdb";
import { Link } from "react-router";

import { assertIsItemInfo, type ItemInfo } from "../common/schema";
import { ItemItem } from "./ItemItem";

export const ItemTemplateLink: FC<{templateId: string; onUnlink: () => void}> = ({templateId, onUnlink}) => {
  const { doc } = useDoc<Partial<ItemInfo>>(templateId);
  let name = templateId;
  if (doc != null) {
    assertIsItemInfo(doc);
    name = doc.name || templateId;
  }
  return <div style={{marginBottom: "6px", padding: "4px 8px", background: "#f5f0e8", borderRadius: "4px", display: "flex", alignItems: "center", gap: "8px"}}>
    <span>Template: <Link to={`/items/${templateId}`}>{name}</Link></span>
    <button type="button" onClick={onUnlink}>Unlink</button>
  </div>;
};

export const ItemTemplateInheritedAttrs: FC<{templateId: string; ownAttrNames: string[]}> = ({templateId, ownAttrNames}) => {
  const { doc } = useDoc<Partial<ItemInfo>>(templateId);
  if (doc == null) return null;
  assertIsItemInfo(doc);
  const inherited = Object.entries(doc.attrs ?? {}).filter(([k]) => !ownAttrNames.includes(k));
  if (inherited.length === 0) return null;
  return <tbody>
    {inherited.map(([k, v]) => (
      <tr key={k} style={{opacity: 0.55}}>
        <td><em>{k}</em></td>
        <td><input type="text" value={v} disabled style={{width: "100%", color: "#666"}} /></td>
      </tr>
    ))}
  </tbody>;
};

export const ItemTemplateNotes: FC<{templateId: string}> = ({templateId}) => {
  const { doc } = useDoc<Partial<ItemInfo>>(templateId);
  if (doc == null) return null;
  assertIsItemInfo(doc);
  if (!doc.notes) return null;
  return <div style={{padding: "6px 8px", background: "#f5f0e8", borderRadius: "4px", marginBottom: "4px", fontSize: "small", whiteSpace: "pre-wrap"}}>
    <em>From template:</em> {doc.notes}
  </div>;
};

export const ItemTemplateChildren: FC<{templateId: string}> = ({templateId}) => {
  const { rows } = useView("built/by_template", { key: templateId, include_docs: true });
  if (rows.length === 0) return <p style={{color: "#888", fontSize: "small"}}>No items use this template yet.</p>;
  return <div>
    <h4 style={{margin: "8px 0 4px"}}>Used by {rows.length} item{rows.length !== 1 ? "s" : ""}</h4>
    <div className="children">
      {rows.map(row => {
        assertIsItemInfo(row.doc);
        return <ItemItem key={row.doc._id} doc={row.doc} />;
      })}
    </div>
  </div>;
};
